// Default max capacity when templateMaxCapacity is null
export const DEFAULT_ONLINE_MAX_CAPACITY = 20;
export const DEFAULT_OFFLINE_MAX_CAPACITY = 12;
